export enum AccreditationStep {
  COMPANY_DATA = 'company_data',
  PERSONAL_DATA = 'personal_data',
  EXPERTS = 'experts',
  HR_DATA = 'hr_data',
  BANKING_ACCESSES = 'banking_accesses',
  EXPERT_PROFILE = 'expert_profile',
  BHP_TEST = 'bhp_test',
  KNF_TEST = 'knf_test',
  AML_TEST = 'aml_test',
  RODO_TEST = 'rodo_test',
  CYBER_TEST = 'cyber_test',
  STMT_TEST = 'stmt_test',
  ETHIC_TEST = 'ethic_test',
}
